// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Is from "../../helpers/Is.res.js";
import * as Icon from "../images-and-icons/Icon.res.js";
import * as Badge from "./Badge.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function theme(kind) {
  switch (kind) {
    case "Information" :
      return {
        borderColor: "#A9C5E7",
        backgroundColor: "#E2EBF7",
        foregroundColor: "#354473"
      };
    case "Important" :
      return {
        borderColor: "#FFD84A",
        backgroundColor: "#FFF5C6",
        foregroundColor: "#7A360D"
      };
    case "Warning" :
      return {
        borderColor: "#FDAB74",
        backgroundColor: "#FFE5CF",
        foregroundColor: "#7C2112"
      };
    case "Danger" :
      return {
        borderColor: "#F8A9CC",
        backgroundColor: "#FCE7F1",
        foregroundColor: "#821938"
      };
    case "Success" :
      return {
        borderColor: "#66EFAC",
        backgroundColor: "#CEFDE0",
        foregroundColor: "#00653E"
      };
    case "Neutral" :
      return {
        borderColor: "#D7D7E0",
        backgroundColor: "#F3F3F7",
        foregroundColor: "#25243A"
      };
    case "Brand" :
      return {
        borderColor: "#F6ABE6",
        backgroundColor: "#FBE8F8",
        foregroundColor: "#4D0A35"
      };
  }
}

function NextBadge(props) {
  let __children = props.children;
  let __icon = props.icon;
  let __shape = props.shape;
  let __size = props.size;
  let __label = props.label;
  let label = __label !== undefined ? __label : "";
  let size = __size !== undefined ? __size : "M";
  let shape = __shape !== undefined ? __shape : "Rounded";
  let icon = __icon !== undefined ? __icon : "None";
  let children = __children !== undefined ? __children : null;
  let match = theme(props.kind);
  let foregroundColor = match.foregroundColor;
  return JsxRuntime.jsxs(Badge.make, {
    children: [
      Is.blankString(label) ? null : label,
      children
    ],
    iconSvg: JsxRuntime.jsx(Icon.make, {
      name: Icon.typeFromNext(icon),
      fill: foregroundColor,
      width: 12,
      height: 12,
      bold: true
    }),
    size: Badge.sizeFromNext(size),
    shape: Badge.shapeFromNext(shape),
    borderColor: match.borderColor,
    backgroundColor: match.backgroundColor,
    foregroundColor: foregroundColor
  });
}

let make = NextBadge;

export {
  theme,
  make,
}
/* Icon Not a pure module */
